const FOOTER = {
  copyright: '© copyright 2025 by Rikzan Fernanda',
  last_update: 'Last updated on August 2025'
}

export default FOOTER
